import { render, staticRenderFns } from "./VoiceBox.vue?vue&type=template&id=ee4d8548"
import script from "./VoiceBox.vue?vue&type=script&lang=js"
export * from "./VoiceBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports